import { Typography, TrustedBy } from "@grantyd/ui";
import styles from "./Partners.module.css";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import YahooFinance from "@/assets/partners/yahoo-finance.png";
import BizTech from "@/assets/partners/biz-tech.png";
import NonProfitPro from "@/assets/partners/non-profit-pro.png";
import TheChronicleOfPhilanthropy from "@/assets/partners/the-chronicle-of-philanthropy.png";
import InvestorsHangout from "@/assets/partners/investors-hangout.jpg";
import MorningStar from "@/assets/partners/morning-star.png";
import SeekingAlpha from "@/assets/partners/seeking-alpha.png";
import { partnersContent } from "@/data/landingpage";

const Partners = () => {
  const isDesktop = useMediaQuery("(min-width: 768px)");

  const trustedByImages = [
    { src: YahooFinance, alt: "Yahoo Finance" },
    { src: BizTech, alt: "BizTech" },
    { src: NonProfitPro, alt: "NonProfitPro" },
    { src: MorningStar, alt: "Morning Star" },
    { src: SeekingAlpha, alt: "Seeking Alpha" },
    { src: TheChronicleOfPhilanthropy, alt: "The Chronicle of Philanthropy" },
    { src: InvestorsHangout, alt: "Investors Hangout" },
  ];

  return (
    <section className={styles.container}>
      <div className={styles.partnersSection}>
        <div className={styles.textBlock}>
          <Typography
            as="h2"
            color="primary"
            variant={isDesktop ? "display-md" : "headline-lg"}
            className={styles.heading}
          >
            {partnersContent.title}
          </Typography>
          <Typography as="p" variant="body-lg" color="primary">
            {partnersContent.subtitle}
          </Typography>
        </div>

        <TrustedBy images={trustedByImages} />

        <div className={styles.ctaBox}>
          <Typography as="h3" variant="headline-md" color="primary">
            {partnersContent.ctaBox.title}
          </Typography>
          <Typography as="p" variant="body-lg" color="primary">
            {partnersContent.ctaBox.description}
          </Typography>
        </div>
      </div>
    </section>
  );
};

export default Partners;
